import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';

import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { MainComponent } from '../main.component';
import { AppComponent } from 'src/app/app.component';
import { CustomForms } from '../../forms/custom-forms';
import { environment } from 'src/environments/environment';

import { IaElementsComponent, IaGridComponent } from 'movisat-ia';

import { jqxMenuComponent } from 'jqwidgets-ng/jqxmenu';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';

import { BdtService } from 'src/app/services/bdt/bdt.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { ConfigService } from 'src/app/services/config/config.service';

import { CasaModel } from 'src/app/services/geographics/casa.model';
import { AmbitoActividadModel } from 'src/app/services/geographics/ambito-actividad.model';

import { KmlComponent } from '../../kml/kml.component';
import { NotasComponent } from '../../notas/notas.component';
import { ZonesComponent } from '../../zones/zones.component';
import { CasaComponent } from '../../maps-tools/casa/casa.component';
import { CalendarComponent } from '../../calendar/calendar.component';
import { MarcoComponent } from '../../maps-tools/marco/marco.component';
import { AmbitoComponent } from '../../maps-tools/ambito/ambito.component';
import { MeasureComponent } from '../../maps-tools/measure/measure.component';
import { SubflotasComponent } from '../../flota/subflotas/subflotas.component';
import { CuadriculasComponent } from '../../cuadriculas/cuadriculas.component';
import { AccionesComponent } from '../../auditoria/acciones/acciones.component';
import { InformesComponent } from '../../auditoria/informes/informes.component';
import { AlarmsgeoComponent } from '../../alarms/alarmsgeo/alarmsgeo.component';
import { ItinerariComponent } from '../../maps-tools/itinerari/itinerari.component';
import { MovilesCercaComponent } from '../../flota/moviles-cerca/moviles-cerca.component';
import { CartoSelectComponent } from '../../maps-tools/carto-select/carto-select.component';
import { AssociateLockComponent } from '../../calendar/associate-lock/associate-lock.component';
import { ListadoVolumComponent } from '../../reports/volum/listado-volum/listado-volum.component';
import { ElementsSelectComponent } from '../../elements/elements-select/elements-select.component';
import { MovilesCatalogComponent } from '../../resources/moviles-catalog/moviles-catalog.component';
import { LopdCiudadanosComponent } from '../../ciudadanos/lopd-ciudadanos/lopd-ciudadanos.component';
import { GridIncidencesComponent } from '../../incidences/grid-incidences/grid-incidences.component';
import { ListadoSensorComponent } from '../../reports/sensor/listado-sensor/listado-sensor.component';
import { ElementsCatalogComponent } from '../../elements/elements-catalog/elements-catalog.component';
import { TarjetasCiudadanosComponent } from '../../tarjetas-ciudadanos/tarjetas-ciudadanos.component';
import { ListadoAlarmasComponent } from '../../reports/alarmas/listado-alarmas/listado-alarmas.component';
import { ListadoTareasComponent } from '../../administrador/tareas/listado-tareas/listado-tareas.component';
import { ListadoMovilidadComponent } from '../../reports/movilidad/listado-movilidad/listado-movilidad.component';
import { ListadoCerraduraComponent } from '../../reports/cerraduras/listado-cerradura/listado-cerradura.component';
import { ConfiguracionCerradurasComponent } from '../../configuracion-cerraduras/configuracion-cerraduras.component';
import { EdificiosInstalacionesListComponent } from '../../edificiosInstalaciones/edificios-instalaciones-list/edificios-instalaciones-list.component';
import { ClusterZoomVisibilityConfigComponent } from '../../cluster-zoom-visibility-config/cluster-zoom-visibility-config.component';
import { CiudadanosValidarComponent } from '../../ciudadanos-validar/ciudadanos-validar.component';
import { GestionTiempoListComponent } from '../../gestion-tiempo/gestion-tiempo-list/gestion-tiempo-list.component';
import { PersonasComponent } from '../../personas/personas.component';
import { GestionEspacialComponent } from '../../gestion-espacial/gestion-espacial.component';
import { VehiculosMaquinariaComponent } from '../../resources/vehiculos-maquinaria/vehiculos-maquinaria.component';
import { PluginsDialogComponent } from 'src/app/dialogs/plugins-dialog/plugins-dialog.component';
import { ElementListInstallComponent } from '../../elements/element-list-install/element-list-install.component';
import { MenuElement } from 'src/app/services/menu/models/menu.model';
import { PluginsMenuManager } from 'src/app/managers/plugins-menu.manager';
import { PluginsManager } from 'src/app/managers/plugins.manager';
import { PluginMapComponent } from '../../plugin-map/plugin-map.component';
import { GoogleDriveService } from 'src/app/services/GoogleDrive/google-drive.service';


enum App {
  ECOEVOLUTION = 3,
  ECOEVOLUTION_DEV = 5,
  ECOSATLITE = 11,
  GESCONSAT = 14
}

const MIN_DISPLAY_WIDTH = 1450;
const DELAY_SUBMENUS_TIME = 200;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements AfterViewInit {
  @ViewChild('menu') menu: jqxMenuComponent;
  @ViewChild('menuContainer', { read: ViewContainerRef }) menuContainer;
  @ViewChild('loader') loader: jqxLoaderComponent;

  public obsListComponent = new BehaviorSubject<any>(null);

  private static instance: MenuComponent;
  public environment = environment;
  public minimized = false;
  private manualTongle = false;
  private menuConTextos = true;
  public options: any[] = [];
  private menuOptions: any = [];

  // Timers para el delay de los submenús
  private openTimeoutSub: Subscription;
  private closeTimeoutSub: Subscription;

  private edificiosExists = false;

  private pluginsSub: Subscription;

  public constructor(
    public menuService: MenuService,
    private zonesService: ZonesService,
    private bdtService: BdtService,
    private configService: ConfigService,
    private pluginsMenuManager: PluginsMenuManager,
    private pluginsManager: PluginsManager,
    private googleDriveService: GoogleDriveService
  ) {
    MenuComponent.instance = this;
    this.checkInstalaciones();
  }

  public static getInstance() {
    return MenuComponent.instance;
  }


  async checkInstalaciones() {
    await this.zonesService.checkInstalaciones().then(
      (result) => {
        this.edificiosExists = false;
      }
    );
  }

  async ngAfterViewInit(): Promise<void> {
    if (window.innerWidth < MIN_DISPLAY_WIDTH) {
      this.minimized = true;
      setTimeout(() => {
        this.tongleMenu(false);
      }, 500);
    }
    // Cuando se redimensiona la ventana del navegador
    window.addEventListener('resize', () => {
      // Si se estrecha mucho la ventana minimizo el menú automáticamente
      if (!this.minimized && window.innerWidth < MIN_DISPLAY_WIDTH) {
        setTimeout(() => {
          this.ponTextosMenu(false);
        }, 500);
        if (!this.manualTongle) {
          setTimeout(() => {
            this.tongleMenu(true);
          }, 500);
          return
        }
      } else {
        // Si se ensancha la ventana lo suficiente y no se ha minimizado manualmente el menú lo maximizo
        if (!this.minimized && window.innerWidth >= MIN_DISPLAY_WIDTH) {
          this.ponTextosMenu(true);
        }
      }
      const menuContainer = document.getElementById('menu-container');
      const centerContainer = document.getElementById('center-container');
      if (this.minimized) {
        menuContainer.style.width = '0px';
        centerContainer.style.width = (window.innerWidth - 0) + 'px';
      } else {
        if (window.innerWidth >= MIN_DISPLAY_WIDTH) {
          menuContainer.style.width = '170px';
          centerContainer.style.width = (window.innerWidth - 171) + 'px';
        } else {
          menuContainer.style.width = '145px';
          centerContainer.style.width = (window.innerWidth - 146) + 'px';
        }
      }

      if (window.screen.width < 768) {
        this.menu.widgetObject.getInstance().items.forEach(element => {
          if (element.level > 1) {
            element.element.parentElement.parentElement.parentElement.style.width = '150px';
            element.element.parentElement.parentElement.style.width = '150px';
            element.element.parentElement.style.width = '150px';
          }
        });

        this.menuOptions.forEach(element => {
          if (element.parentid > 0) {
            this.menu.setItemOpenDirection(element.id, 'center', 'center');
          }
        });
      } else {
        this.menu.widgetObject.getInstance().items.forEach(element => {
          if (element.level > 1) {
            element.element.parentElement.parentElement.parentElement.style.width = '230px';
            element.element.parentElement.parentElement.style.width = '230px';
            element.element.parentElement.style.width = '230px';
          }
        });

        this.menuOptions.forEach(element => {
          if (element.parentid > 0) {
            this.menu.setItemOpenDirection(element.id, 'right', 'down');
          }
        });
      }
    });
    // Genero el evento para que se visualice el menú
    window.dispatchEvent(new Event('resize'));

    this.pluginsSub = this.pluginsManager.enabledPlugins$.subscribe(() => {
      this.loadMenu();
      this.addSubmenuListeners();
    });


  }

  private addSubmenuListeners(): void {
    // Para asegurarnos de que JqWidgets no sobreescriba ningún comportamiento
    // debemos aplicar aquí un timer
    timer(500).subscribe(() => {
      const submenus = document.querySelectorAll('.jqx-menu-dropdown');
      const menuItems = document.querySelectorAll('.jqx-item');

      menuItems.forEach((menuItem) => {
        menuItem.addEventListener('mouseenter', () => this.openMenuWithDelay(menuItem as HTMLElement));
        menuItem.addEventListener('mouseleave', () => this.closeAllSubmenusWithDelay());
      });

      submenus.forEach((submenu) => {
        submenu.addEventListener('mouseenter', () => this.cancelCloseMenu());
        submenu.addEventListener('mouseleave', () => this.closeAllSubmenusWithDelay());
      });
    });
  }

  private openMenuWithDelay(menuItem: HTMLElement): void {
    this.openTimeoutSub?.unsubscribe();
    this.closeTimeoutSub?.unsubscribe();

    this.openTimeoutSub = timer(DELAY_SUBMENUS_TIME).subscribe(() => {
      const id = menuItem.getAttribute("id");
      this.menu.openItem(id);
    });
  }

  private closeAllSubmenusWithDelay(): void {
    this.closeTimeoutSub?.unsubscribe();

    this.closeTimeoutSub = timer(DELAY_SUBMENUS_TIME).subscribe(() => {
      const topMenuItems = document.querySelectorAll<HTMLElement>('.jqx-item');
      topMenuItems.forEach(item => {
        if (item.classList.contains('jqx-menu-item-top-selected')) {
          this.menu.closeItem(item.getAttribute("id"));
        }
      });
    });
  }

  private cancelCloseMenu(): void {
    this.closeTimeoutSub?.unsubscribe();
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public updateListComponent(listComponentsMenu) {
    this.obsListComponent.next(listComponentsMenu);
  }

  public disableOption(optionToDisable: string, state: boolean): void {
    const idMenu = this.menuOptions.find(mo => mo.value === optionToDisable).id;
    if (!idMenu) {
      return;
    }
    this.menu.disable(idMenu, state)
  }

  public loadMenu(): void {
    const t = setTimeout(async () => {
      clearTimeout(t);
      // Cargo el menú que se ha obtenido en AppComponent
      const menuData = AppComponent.getInstance().menuData;
      const user = MainComponent.getInstance().ssoTicket.Usuario;
      const menuOptions: MenuElement[] = [];
      if (menuData && menuData.Opciones) {
        menuData.Opciones.forEach(item => {
          if (!item.SoloMovisat || (item.SoloMovisat && user.Interno)) {
            menuOptions.push(
              {
                id: item.Id,
                text: "<div style='color: lightgray;'>" + MainComponent.translate(item.TextoId) + '</div>',
                parentid: item.PadreId > 0 ? item.PadreId : -1,
                subMenuWidth: '230px',
                value: item.AccionId,
                textId: item.TextoId,
                menuOpcionId: item.OpcionOriginalId
              }
            );
          }
        });
        // FIXME: This is only required for the plugins. When plugins are not needed anymore, please, remove this. //
        this.insertPluginsMenus(menuOptions);
      }

      // Pongo en negrita las opciones que tienen asociada alguna acción
      for (let i = 0, j = 0; i < menuData.Opciones.length; i++, j++) {
        if (!menuData.Opciones[i].SoloMovisat || (menuData.Opciones[i].SoloMovisat && user.Interno)) {

          let disable = !menuOptions[j].value;
          /* TODO: cambiar value en if por el que corresponde */
          if (menuOptions[j].value === "EDIFICIOS_INSTALACIONES" && !this.edificiosExists) {
            menuOptions[j].value = '';
            disable = true;
          }

          if (!disable) {
            menuOptions[j].text = menuOptions[j].text.replace('lightgray', 'black');
          }
          let currentItem = { ...menuData.Opciones[i] };
          while (currentItem.PadreId > 0 && !disable) {
            const parentItem = menuData.Opciones.find(f => f.Id === currentItem.PadreId);
            if (parentItem) {
              const mOpt = menuOptions.find(f => f.id === parentItem.Id);
              if (mOpt) {
                mOpt.text = mOpt.text.replace('lightgray', 'black');
              }
              currentItem = { ...parentItem };
            } else {
              break;
            }
          }
        } else {
          j--;
        }
      }
      // Muestro el menú
      const source = {
        datatype: "json",
        datafields: [
          { name: 'id' },
          { name: 'parentid' },
          { name: 'text' },
          { name: 'subMenuWidth' },
          { name: 'value' }
        ],
        id: 'id',
        localdata: menuOptions
      };
      const dataAdapter = new jqx.dataAdapter(source);
      dataAdapter.dataBind();
      const records = dataAdapter.getRecordsHierarchy('id', 'parentid', 'items', [{ name: 'text', map: 'label' }]);
      this.menu.source(records);
      this.menuOptions = menuOptions;
      this.checkMenuOption(menuOptions);
      const idEdificio = this.menuOptions.find(opt => opt.textId === 'Edificios_instalaciones')?.id;
      const option = idEdificio ? document.getElementById(idEdificio.toString()) as HTMLElement : null;
      if (option) {
        option.title = AppComponent.translate('Crea_edificio_instalacion_primero');
      }
    }, 0);
  }

  private insertPluginsMenus(menu: MenuElement[]): void {
    const pluginsContainer = this.pluginsMenuManager.setPluginsContainer(menu);
    if (pluginsContainer) {
      menu.push(pluginsContainer);

      const pluginMenus = this.pluginsMenuManager.addPluginMenu();
      menu.push(...pluginMenus);
    }
  }

  public async viewAmbito(): Promise<boolean> {
    const res = await this.configService.getEmpApp('ambito-actividad', null);
    const ambito: AmbitoActividadModel = JSON.parse(res);
    return ambito && ambito.marco !== null;
  }

  // Si no existe ámbito de actividad y no exsite marco geografico no se muestra el menu
  public async checkMenuOption(listOptions: any[]) {
    if (!await this.viewAmbito()) {
      // Estas son las opciones que están activas cuando no se ha definido ámbito
      const menuOptionsEnabled: string[] = [
        'Configuracion',
        'Gestion'
      ]

      const subMenuOptionsEnabled: string[] = [
        'Cartografia',
        'Marco_geografico',
        'Ambito_actividad',
        'Gestion_espacial',
        'Edificios_instalaciones',
      ]

      // Si no existe ámbito de actividad sólo se muestran las opciones de configuracion
      listOptions.forEach(element => {

        if (subMenuOptionsEnabled.find(o => o === element.textId) && element.parentid !== -1) {
          return;
        }

        if(menuOptionsEnabled.find(o => o === element.textId) && element.parentid === -1) {
          return;
        }

        this.menu.disable(element.id, true);
      });
    }
  }

  onItemClick(event: any) {
    let component, component2;
    if (event.args.attributes['item-value'].value) {
      /*
        En caso de que se clicke en un elemento que tenga accion cierra el menu
        se hace aqui para que en el movil funcione correctamente
      */
      this.menu.elementRef.nativeElement.children[0].children[0].childNodes.forEach(element => {
        this.menu.closeItem(element.id);
      });

      // Almaceno la última acción del menú pulsada
      CustomForms.lastActionMenu = event.args.attributes['item-value'].value;
      CustomForms.lastOptionMenu = this.menuOptions.find((opt) => opt.id === Number.parseInt(event.args.id));

      switch (event.args.attributes['item-value'].value) {
        case 'CARTOGRAFIA_HERRAMIENTAS_MEDIR':
          if (MeasureComponent && MeasureComponent._this && MeasureComponent._this.form) {
            MeasureComponent._this.form.bringToFront();
            MeasureComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(MeasureComponent);
            component.instance.init(component);
          }
          break;

        case 'CARTOGRAFIA_POLIGONOS':
          if (ZonesComponent && ZonesComponent._this && ZonesComponent._this.form) {
            ZonesComponent._this.form.bringToFront();
            ZonesComponent._this.form.window.expand();
          } else {
            component = this.menuContainer.createComponent(ZonesComponent);
            component.instance.init(component, true);
          }
          break;

        case 'CARTOGRAFIA_NUEVA_VISTA':
          MainComponent.createMap(null, null, true, null);
          break;

        case 'CARTOGRAFIA_HERRAMIENTAS_DEF_CUADRICULAS':
          if (CuadriculasComponent && CuadriculasComponent._this && CuadriculasComponent._this.form) {
            CuadriculasComponent._this.form.bringToFront();
            CuadriculasComponent._this.form.expandWindow();
          } else {
            component = this.menuContainer.createComponent(CuadriculasComponent);
            component.instance.init(component);
          }
          break;

        case 'CARTOGRAFIA_ZONAS':
          if (ZonesComponent && ZonesComponent._this && ZonesComponent._this.form) {
            ZonesComponent._this.form.bringToFront();
            ZonesComponent._this.form.window.expand();
          } else {
            component = this.menuContainer.createComponent(ZonesComponent);
            component.instance.init(component, false, null, false);
          }
          break;

        // Configuración/Gestión/Gestión espacial
        case 'CONFIG_GEST_ESPACIAL':
          if (GestionEspacialComponent && GestionEspacialComponent._this && GestionEspacialComponent._this.window) {
            GestionEspacialComponent._this.window.bringToFront();
            GestionEspacialComponent._this.window.expand();
          }
          else {
            component = this.menuContainer.createComponent(GestionEspacialComponent);
            component.instance.init(component);
          }


          break;

        case 'CONFIG_CARTOGRAFIA_CLUSTER_ZOOM':
          if (ClusterZoomVisibilityConfigComponent && ClusterZoomVisibilityConfigComponent._this && ClusterZoomVisibilityConfigComponent._this.window) {
            ClusterZoomVisibilityConfigComponent._this.window.bringToFront();
            ClusterZoomVisibilityConfigComponent._this.window.expand();
          }
          else {
            component = this.menuContainer.createComponent(ClusterZoomVisibilityConfigComponent);
            component.instance.init(component);
          }
          break;

        case 'RECURSOS_EDIF_INST':
          if (EdificiosInstalacionesListComponent && EdificiosInstalacionesListComponent._this && EdificiosInstalacionesListComponent._this.windowEdificios) {
            EdificiosInstalacionesListComponent._this.windowEdificios.bringToFront();
            EdificiosInstalacionesListComponent._this.windowEdificios.expand();
          } else {
            component = this.menuContainer.createComponent(EdificiosInstalacionesListComponent);
            component.instance.init(component);
          }
          break;

        case 'CARTOGRAFIA_CASA':
          this.centrarCasa();
          break;

        case 'CATALOGO_FLOTA':
          component = this.menuContainer.createComponent(VehiculosMaquinariaComponent);
          component.instance.init(component);
          break;

        case 'MOVILES':
          MainComponent.getInstance().toggleTabVisibility('MOVILES', true, MainComponent.MOVILES_TAB);
          break;

        case 'MOVILIDAD_FLOTA_SUBFLOTAS':
          if (SubflotasComponent && SubflotasComponent._this && SubflotasComponent._this.form) {
            SubflotasComponent._this.form.bringToFront();
            SubflotasComponent._this.form.expandWindow();
          } else {
            component = this.menuContainer.createComponent(SubflotasComponent);
            component.instance.init(component);
          }
          break;

        case 'MOVILIDAD_FLOTA_RECORRIDOS':
          document.getElementById('btnRecorrido').click();
          break;

        case 'MOVILIDAD_FLOTA_ITINERARIOS':
          if (ItinerariComponent && ItinerariComponent._this && ItinerariComponent._this.ventana) {
            ItinerariComponent._this.ventana.bringToFront();
            ItinerariComponent._this.ventana.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ItinerariComponent);
            component.instance.init(component, 0);
          }
          break;

        case 'MOVILIDAD_MOVILES_CERCANOS':
          MainComponent.getInstance().tabGestion.selectAt(MainComponent.MOVILES_TAB);

          if (MovilesCercaComponent && MovilesCercaComponent._this && MovilesCercaComponent._this.form) {
            MovilesCercaComponent._this.form.bringToFront();
            MovilesCercaComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(MovilesCercaComponent);
            component.instance.init(component, 0);
          }
          break;

        case 'MOVILIDAD_ALARMAS_GEO':
          if (AlarmsgeoComponent && AlarmsgeoComponent._this && AlarmsgeoComponent._this.form) {
            AlarmsgeoComponent._this.form.bringToFront();
            AlarmsgeoComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(AlarmsgeoComponent);
            component.instance.init(component);
          }
          break;

        case 'INFOR_LISTADO_IDENTIF_CERRADURAS':
          MainComponent.createTabInfo('Historicos_identificaciones', true);
          break;

        case 'INFOR_LISTADO_ALARMAS_CERRADURAS':
          MainComponent.createTabInfo('Listado_alarmas_geo', true);
          break;

        case 'INFOR_LISTADO_INSTALACIONES':
          if (ElementListInstallComponent && ElementListInstallComponent._this && ElementListInstallComponent._this.windowsListInstall) {
            ElementListInstallComponent._this.windowsListInstall.bringToFront();
            ElementListInstallComponent._this.windowsListInstall.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ElementListInstallComponent);
            component.instance.init(component);
          }
          break;

        case 'CATALOGO_ELEMENTOS':
          if (ElementsCatalogComponent && ElementsCatalogComponent._this && ElementsCatalogComponent._this.form && !(ElementsCatalogComponent._this.fromIAConfig)) {
            ElementsCatalogComponent._this.form.bringToFront();
            ElementsCatalogComponent._this.form.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ElementsCatalogComponent, false);
            component.instance.init(component);
          }
          break;

        case 'ELEMENTOS':
          MainComponent.getInstance().toggleTabVisibility('ELEMENTOS', true, MainComponent.ELEMENTOS_TAB);
          break;

        case 'PUNTOS_UBICACION':
          MainComponent.getInstance().toggleTabVisibility('PUNTOS_UBICACION', true, MainComponent.PU_TAB);
          break;

        case 'IA_ESTUDIO_ACTUAL':
          MainComponent.getInstance().toggleTabVisibility('IA_ESTUDIO_ACTUAL', true, MainComponent.IA_TAB);
          MainComponent.getInstance().rightContainer.clear();
          // Creo los componentes IA
          component = this.menuContainer.createComponent(IaElementsComponent);
          component.instance.init(component);
          // El grid de elementos...
          MainComponent.getInstance().gridElemIaContainer.clear();
          component2 = MainComponent.getInstance().gridElemIaContainer.createComponent(IaGridComponent);
          component2.instance.init(component2);
          break;

        case 'CONFIG_CARTOGRAFIA_MARCO_GEO':
          if (MarcoComponent && MarcoComponent._this && MarcoComponent._this.form) {
            MarcoComponent._this.form.bringToFront();
            MarcoComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(MarcoComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CARTOGRAFIA_CASA':
          if (CasaComponent && CasaComponent._this && CasaComponent._this.form) {
            CasaComponent._this.form.bringToFront();
            CasaComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(CasaComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CARTOGRAFIA_AMBITO_ACTIVIDAD':
          if (AmbitoComponent && AmbitoComponent._this && AmbitoComponent._this.form) {
            AmbitoComponent._this.form.bringToFront();
            AmbitoComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(AmbitoComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CARTOGRAFIA_PROV_CARTO':
          if (CartoSelectComponent && CartoSelectComponent._this && CartoSelectComponent._this.form) {
            CartoSelectComponent._this.form.bringToFront();
            CartoSelectComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(CartoSelectComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_MOVILIDAD_SUBFLOTAS':
          if (SubflotasComponent && SubflotasComponent._this && SubflotasComponent._this.form) {
            SubflotasComponent._this.form.bringToFront();
            SubflotasComponent._this.form.expandWindow();
          } else {
            component = this.menuContainer.createComponent(SubflotasComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_MOVILES_IA':
          if (MovilesCatalogComponent && MovilesCatalogComponent._this && MovilesCatalogComponent._this.form) {
            MovilesCatalogComponent._this.form.bringToFront();
            MovilesCatalogComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(MovilesCatalogComponent);
            component.instance.init(component, true);
          }
          break;

        case 'CONFIG_ELEMENTOS_IA':
          if (ElementsCatalogComponent && ElementsCatalogComponent._this && ElementsCatalogComponent._this.form && ElementsCatalogComponent._this.fromIAConfig) {
            ElementsCatalogComponent._this.form.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ElementsCatalogComponent);
            component.instance.init(component, true);
          }
          break;

        case 'LISTADO_MOVILIDAD':
          if (ListadoMovilidadComponent && ListadoMovilidadComponent._this && ListadoMovilidadComponent._this.form) {
            ListadoMovilidadComponent._this.form.bringToFront();
            ListadoMovilidadComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ListadoMovilidadComponent);
            component.instance.init(component);
          }
          break;

        case 'LISTADO_VOLUMETRICOS':
          if (ListadoVolumComponent && ListadoVolumComponent._this && ListadoVolumComponent._this.form) {
            ListadoVolumComponent._this.form.bringToFront();
            ListadoVolumComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ListadoVolumComponent);
            component.instance.init(component);
          }
          break;

        case 'LISTADO_SENSORES':
          if (ListadoSensorComponent && ListadoSensorComponent._this && ListadoSensorComponent._this.form) {
            ListadoSensorComponent._this.form.bringToFront();
            ListadoSensorComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ListadoSensorComponent);
            component.instance.init(component);
          }
          break;

        case 'LISTADO_ALARMAS_GEO':
          if (ListadoAlarmasComponent && ListadoAlarmasComponent._this && ListadoAlarmasComponent._this.form) {
            ListadoAlarmasComponent._this.form.bringToFront();
            ListadoAlarmasComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ListadoAlarmasComponent);
            component.instance.init(component);
          }
          break;

        case 'INFOR_LISTADO_CERRADURAS':
          if (ListadoCerraduraComponent && ListadoCerraduraComponent.instance && ListadoCerraduraComponent.instance.listCerraduras) {
            ListadoCerraduraComponent.instance.listCerraduras.bringToFront();
            ListadoCerraduraComponent.instance.listCerraduras.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ListadoCerraduraComponent);
            component.instance.init(component);
          }
          break;

        case 'INFOR_HIST_ENVIOS_CERRADURAS':
          MainComponent.createTabInfo('Historico_envios_dispositivo_identificador', true);
          break;

        case 'CONFIG_CARTOGRAFIA_KML':
          if (KmlComponent && KmlComponent._this && KmlComponent._this.form) {
            KmlComponent._this.form.bringToFront();
            KmlComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(KmlComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_ELEMENTOS_SELEC':
          if (ElementsSelectComponent && ElementsSelectComponent._this && ElementsSelectComponent._this.form) {
            ElementsSelectComponent._this.form.bringToFront();
            ElementsSelectComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ElementsSelectComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CALENDARIOS':
          if (CalendarComponent && CalendarComponent._this && CalendarComponent._this.form) {
            CalendarComponent._this.form.bringToFront();
            CalendarComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(CalendarComponent);
            component.instance.init(component);
          }
          break;

        case 'GESTION_INCIDENCIAS':
          if (GridIncidencesComponent && GridIncidencesComponent._this && GridIncidencesComponent._this.windowIncidences) {
            GridIncidencesComponent._this.windowIncidences.bringToFront();
            GridIncidencesComponent._this.windowIncidences.expand();
          } else {
            component = this.menuContainer.createComponent(GridIncidencesComponent);
            component.instance.init(component);
          }
          break;

        case 'BDT_SINCRONIZAR':
          this.loader.open();
          setTimeout(async () => {
            this.bdtService.sincronizaBDT();
            this.loader.close();
          }, 2000);

          break;

        case 'DOC_MANUAL_USUARIO':
          let urlFile = '';
          //seleccionar url según app
          switch (MainComponent.getInstance().ssoTicket.Aplicacion.Id) {
            case App.ECOEVOLUTION:
              urlFile = 'https://docs.google.com/document/d/1tcb9uHU06AWTnd5wabIe2oSca1mC1GdO/edit?usp=sharing&ouid=104449151105465490839&rtpof=true&sd=true';
              break;
            case App.ECOEVOLUTION_DEV:
              urlFile = 'https://docs.google.com/document/d/1tcb9uHU06AWTnd5wabIe2oSca1mC1GdO/edit?usp=sharing&ouid=104449151105465490839&rtpof=true&sd=true';
              break;
            case App.ECOSATLITE:
              urlFile = 'https://docs.google.com/document/d/1s8EHYwiuAbRWNSiBnK7W5ucwvNcU1mV_/edit?usp=sharing&ouid=104449151105465490839&rtpof=true&sd=true';
              break;
            case App.GESCONSAT:
              urlFile = 'https://docs.google.com/document/d/16Y0gEJl_b65bxyC4SvWXY05dsefiW6Uo/edit?usp=sharing&ouid=104449151105465490839&rtpof=true&sd=true';
              break;
            //ecosat por defecto
            default:
              urlFile = 'https://docs.google.com/document/d/1ti89RHeiMbBRDhA8vP5ecLJbfCVzngvR/edit?usp=sharing&ouid=104449151105465490839&rtpof=true&sd=true';
              break;
          }
          //abrir documento en una nueva ventana
          window.open(urlFile);
          break;

        case 'ANOTACIONES':
          if (NotasComponent && NotasComponent._this && NotasComponent._this.form) {
            NotasComponent._this.form.bringToFront();
            NotasComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(NotasComponent);
            component.instance.init(component);
          }
          break;

        case 'AUDITORIA_ACCIONES':
          if (AccionesComponent && AccionesComponent._this && AccionesComponent._this.form) {
            AccionesComponent._this.form.bringToFront();
            AccionesComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(AccionesComponent);
            component.instance.init(component);
          }

          break;

        case 'AUDITORIA_INFORMES':
          if (InformesComponent && InformesComponent._this && InformesComponent._this.form) {
            InformesComponent._this.form.bringToFront();
            InformesComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(InformesComponent);
            component.instance.init(component);
          }
          break;

        case 'GESTION_CIUDADANOS':
        case 'ELEM_CIUDADANOS':
          MainComponent.getInstance().toggleTabVisibility('GESTION_CIUDADANOS', true, MainComponent.CIUDADANOS_TAB);
          break;

        case 'CONFIG_LOPD':
          if (!LopdCiudadanosComponent._this) {
            component = this.menuContainer.createComponent(LopdCiudadanosComponent);
            component.instance.init(component);
          } else {
            LopdCiudadanosComponent._this.window.bringToFront();
            LopdCiudadanosComponent._this.window.expand();
          }
          break;

        case 'CONFIG_GEST_CIUDADANOS':
          if (CiudadanosValidarComponent && CiudadanosValidarComponent._this && CiudadanosValidarComponent._this.form) {
            CiudadanosValidarComponent._this.form.bringToFront();
            CiudadanosValidarComponent._this.form.expand();
          }
          else {
            component = this.menuContainer.createComponent(CiudadanosValidarComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CERRADURAS_CONFIGURAR':
          if (ConfiguracionCerradurasComponent && ConfiguracionCerradurasComponent._this && ConfiguracionCerradurasComponent._this.form) {
            ConfiguracionCerradurasComponent._this.form.bringToFront();
            ConfiguracionCerradurasComponent._this.form.expand();
          } else {
            component = this.menuContainer.createComponent(ConfiguracionCerradurasComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_CERRADURAS_CALENDARIOS':
          if (AssociateLockComponent && AssociateLockComponent._this && AssociateLockComponent._this.formAssociate) {
            AssociateLockComponent._this.formAssociate.bringToFront();
            AssociateLockComponent._this.formAssociate.expandWindow();
          } else {
            component = this.menuContainer.createComponent(AssociateLockComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_ADMINISTRADOR_JOBS':
          if (ListadoTareasComponent && ListadoTareasComponent._this && ListadoTareasComponent._this.window) {
            ListadoTareasComponent._this.window.bringToFront();
            ListadoTareasComponent._this.window.expandWindow();
          } else {
            component = this.menuContainer.createComponent(ListadoTareasComponent);
            component.instance.init(component);
          }
          break;

        case 'CONFIG_GEST_TIEMPO':
          component = this.menuContainer.createComponent(GestionTiempoListComponent);
          component.instance.init(component);
          break;

        case 'REC_TARJ_CIUD':
          if (TarjetasCiudadanosComponent && TarjetasCiudadanosComponent._this && TarjetasCiudadanosComponent._this.window) {
            TarjetasCiudadanosComponent._this.window.bringToFront();
            TarjetasCiudadanosComponent._this.window.expandWindow();
          } else {
            component = this.menuContainer.createComponent(TarjetasCiudadanosComponent);
            component.instance.init(component);
          }
          break
        case 'PERSONAS':
          if (PersonasComponent && PersonasComponent._this && PersonasComponent._this.listPersonas) {
            PersonasComponent._this.listPersonas.bringToFront();
            PersonasComponent._this.listPersonas.expandWindow();
          } else {
            component = this.menuContainer.createComponent(PersonasComponent);
            component.instance.init(component);
          }
          break;
        case 'CONFIG_PLUGINS':
          if (PluginsDialogComponent && PluginsDialogComponent._this && PluginsDialogComponent._this.pluginsWindow) {
            PluginsDialogComponent._this.pluginsWindow().bringToFront();
            PluginsDialogComponent._this.pluginsWindow().expandWindow();
          } else {
            component = this.menuContainer.createComponent(PluginsDialogComponent);
          }
          break;
        case 'GESTOR_ARCHIVOS':
          this.googleDriveService.downloadSelectedFile()
          break;
        case 'VISUALIZADOR_WMS':
          if (PluginMapComponent && PluginMapComponent._this && PluginMapComponent._this.mapWindow) {
            PluginMapComponent._this.mapWindow.bringToFront();
            PluginMapComponent._this.mapWindow.expandWindow();
          } else {
            component = this.menuContainer.createComponent(PluginMapComponent);
          }
          break;
        default:
          break;
      }
      setTimeout(() => {
        if (component !== undefined || component !== null) {
          this.updateListComponent(component);
        }
      }, 200);
    }
  }

  async centrarCasa() {
    const res = await this.configService.getEmpApp('casa', null);
    if (res) {
      const casa: CasaModel = JSON.parse(res);
      MainComponent.getActiveMap().setZoom(casa.zoom);
      MainComponent.getActiveMap().setCenter(casa.posicion);
    }
  }

  tongleMenu(manual: boolean) {
    this.manualTongle = manual;
    // Cuando se minimiza el menú muevo hacia la derecha el texto del mapa0 para que no se superponga
    const map0: any = document.getElementById('mapaPrincipal');
    if (!this.minimized) {
      map0.style.cssText = 'float: left; margin-left: 40px;';
    } else {
      map0.style.cssText = 'float: left;';
    }
    if (window.innerWidth < MIN_DISPLAY_WIDTH) {
      // Quito los textos del menú
      this.ponTextosMenu(false);
    } else {
      // Vuelvo a poner los textos del menú
      this.ponTextosMenu(true);
    }
    this.minimized = !this.minimized;
    window.dispatchEvent(new Event('resize'));
  }

  ponTextosMenu(conTextos: boolean) {
    this.menuConTextos = conTextos;
  }
}
